
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import FinancePaymentConfirmationList from '@/components/finance/FinancePaymentConfirmationList';

const FinancePaymentsConfirmation = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Payment Confirmation</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Payment Confirmation</CardTitle>
            <CardDescription>
              Mark approved procurements as paid after payment has been made
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FinancePaymentConfirmationList />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinancePaymentsConfirmation;
